import React, { useRef, useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { NavBarDesktop } from './NavBarDesktop'
import { NavBarMobile } from './NavBarMobile'
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { selectUser } from '../../redux/userSlice'

export function NavBar() {
  const [tab, setTab] = useState('none')
  const navigate = useNavigate()
  const navRef = useRef()
  const isNavMegaPannelOpen = tab !== 'none' && tab !== 'burger' && tab !== 'report' && tab !== 'tribal_report'

  const user = useSelector(selectUser)
  const [userPermissions, setUserPermissions] = useState([])

  useEffect(() => {
    if (user) {
      if (user.spoofed_user.user_permission_options) {
        setUserPermissions(user.spoofed_user.user_permission_options)
      } else if (user.data && user.data.user_permission_options) {
        setUserPermissions(user.data.user_permission_options)
      }
    }
  }, [user])

  function collapse() {
    setTab('none')
  }
  function changeTab(newTab) {
    collapse()
    if (newTab === tab) {
      return
    }
    setTab(newTab)
  }

  const goBackToHistory = () => {
    navigate(-1);
  }

  return (
    <span className="lox-navigation-bar">
      <nav
        className={`${process.env.REACT_APP_ENVIRONMENT !== 'production' ? 'dev-env-color' : ''} navbar is-primary is-transparent lox-navigation-bar__content`}
        ref={navRef}
      >
        <div className="navbar-brand">
          <span
            className="navbar-item"
            onClick={() => goBackToHistory()}
            title="Back Button"
          >
            <FontAwesomeIcon icon={faArrowLeftLong} className={'fa-xl'} />
          </span>
          <a
            className="navbar-burger burger"
            id="burger"
            // onClick={() => changeTab('burger')}
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>

        {tab === 'burger' ? (
          <NavBarMobile tab={tab} changeTab={changeTab} collapse={collapse} />
        ) : (
          <NavBarDesktop
            tab={tab}
            changeTab={changeTab}
            collapse={collapse}
            userPermissions={userPermissions}
          />
        )}
      </nav>

      {isNavMegaPannelOpen && <span className="lox-navigation-bar__overlay" onClick={collapse} />}

    </span>
  )
}
